import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static targets = ["carousel"]

  connect() {
    this.element.addEventListener("show.bs.modal", this.handleShow.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("show.bs.modal", this.handleShow.bind(this))
  }

  handleShow(event) {
    const button = event.relatedTarget
    const carouselIndex = button?.getAttribute("data-carousel-index")

    if (carouselIndex !== null && this.hasCarouselTarget) {
      const bsCarousel = bootstrap.Carousel.getOrCreateInstance(this.carouselTarget)
      bsCarousel.to(parseInt(carouselIndex))
    }
  }
}
